import { t } from '@lingui/macro'
import { type } from 'arktype'

import { MAX_PARAMETER_WEIGHT } from './constants'

const parameter = type({
  filterValueType: type.string,
  value: type.object
    .required()
    .configure({ message: () => t`Parameter must have a value` }),
  weight: type.number.moreThan(0).lessThan(MAX_PARAMETER_WEIGHT + 1),
})

export const validationSchema = type({
  uid: type.string.optional(),
  name: type.string.configure({
    message: () => t`Please add a name`,
  }),
  description: type.string.optional(),
  parameters: parameter
    .array()
    .moreThanLength(0)
    .configure({
      message: () => t`Add at least one parameter`,
    }),
})
